import Folder from './Folder';

export default Folder;
